<template>
  <div id="colorado-sounds">
    <h1>WAS ICH SAH UND HöRTE</h1>
    <div class="content-wrapper">
      <img src="../assets/img/colorado_sounds_1.jpg" alt="Mountains" class="img-1">
      <img src="../assets/img/colorado_sounds_2.jpg" alt="Wood Storage" class="img-2">
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'ColoradoSounds'
}
</script>

<style lang='scss'>
  #colorado-sounds {
    .content-wrapper {
      text-align: center;
      .img-1 {
        width: 100%;
        margin-bottom: 50px;
      }
    }
  }
  @media screen and (max-width: 750px) {
    #colorado-sounds {
    .content-wrapper {
      .img-2 {
        width: 100%;
      }
    }
  }
  }
</style>
